import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { useSelector } from 'react-redux'

function CalendarioSemanalComponent(props) {

    return (
        <>
        <div className='row text-center'>
            <h1>Calendario Semanal</h1>
        </div>
        </>
    );
};


export default withRouter(CalendarioSemanalComponent)